import React from 'react';
import PropTypes from 'prop-types';

import { CELL_TYPES } from '../../enums';
import { useLineItemSelector } from '../../context';
import Cell from '../Cell';

import styles from './line.module.css';

const Pricing = ({ id, disabled, discountDisabled, msrp, discount, percentage, adjusted, extended, locked }) => {
  const isDiscountFilled = useLineItemSelector(lineItem => lineItem.discount !== null);
  return (
    <>
      <Cell type={CELL_TYPES.currency} alias={msrp} disabled={disabled} className={styles.msrp} />
      <Cell
        type={locked ? CELL_TYPES.currency : CELL_TYPES.amount}
        id={id}
        alias={discount}
        max={msrp}
        disabled={disabled || discountDisabled}
        className={styles.discountAmount}
      />
      <Cell
        type={!disabled && !discountDisabled && isDiscountFilled ? CELL_TYPES.percentage : CELL_TYPES.empty}
        alias={percentage}
        disabled={disabled || discountDisabled}
        className={styles.discountPercentage}
      />
      <Cell type={disabled ? CELL_TYPES.empty : CELL_TYPES.currency} alias={adjusted} disabled={disabled} />
      <Cell type={disabled ? CELL_TYPES.empty : CELL_TYPES.currency} alias={extended} disabled={disabled} />
    </>
  );
};

Pricing.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  discountDisabled: PropTypes.bool,
  msrp: PropTypes.string,
  discount: PropTypes.string,
  percentage: PropTypes.string,
  adjusted: PropTypes.string,
  extended: PropTypes.string,
};

Pricing.defaultProps = {
  active: true,
};

export default Pricing;
